module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_vm._l((_vm.errors), function(e, index) {
    return _c('ui-alert', {
      key: index,
      attrs: {
        "type": "error"
      },
      on: {
        "dismiss": function($event) {
          _vm.dismissErrors()
        }
      }
    }, [_vm._v(_vm._s(e))])
  }), _vm._v(" "), _c('ui-textbox', {
    attrs: {
      "label": "E-mail",
      "name": "email",
      "type": "text",
      "autofocus": _vm.autofocus,
      "validation-rules": "required|email",
      "validation-messages": _vm.errorMessages,
      "placeholder": "Wpisz e-mail"
    },
    model: {
      value: (_vm.item.email),
      callback: function($$v) {
        _vm.item.email = $$v
      },
      expression: "item.email"
    }
  }), _vm._v(" "), _c('ui-textbox', {
    attrs: {
      "label": "Imię",
      "name": "first_name",
      "type": "text",
      "validation-rules": "required",
      "validation-messages": _vm.errorMessages,
      "placeholder": "Wpisz imię"
    },
    model: {
      value: (_vm.item.first_name),
      callback: function($$v) {
        _vm.item.first_name = $$v
      },
      expression: "item.first_name"
    }
  }), _vm._v(" "), _c('ui-textbox', {
    attrs: {
      "label": "Nazwisko",
      "name": "last_name",
      "type": "text",
      "validation-rules": "required",
      "validation-messages": _vm.errorMessages,
      "placeholder": "Wpisz nazwisko"
    },
    model: {
      value: (_vm.item.last_name),
      callback: function($$v) {
        _vm.item.last_name = $$v
      },
      expression: "item.last_name"
    }
  }), _vm._v(" "), (!this.item.id) ? _c('div', [_c('ui-textbox', {
    attrs: {
      "label": "Hasło",
      "name": "password",
      "type": "password",
      "validation-rules": "required",
      "validation-messages": _vm.errorMessages,
      "placeholder": "Wpisz hasło"
    },
    model: {
      value: (_vm.item.password),
      callback: function($$v) {
        _vm.item.password = $$v
      },
      expression: "item.password"
    }
  }), _vm._v(" "), _c('ui-textbox', {
    attrs: {
      "label": "Hasło (wpisz ponownie)",
      "name": "password2",
      "type": "password",
      "validation-rules": "required",
      "validation-messages": _vm.errorMessages,
      "placeholder": "Wpisz hasło ponownie"
    },
    model: {
      value: (_vm.item.password2),
      callback: function($$v) {
        _vm.item.password2 = $$v
      },
      expression: "item.password2"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-actions"
  }, [_c('ui-button', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v(_vm._s(_vm.item.id ? 'Aktualizuj' : 'Dodaj'))])], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c03ed532","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/users/Form.vue
// module id = 284
// module chunks = 0